module.exports = __webpack_public_path__ + "img/giphy2.575b1cd9.gif";